import * as header from '@grupa-pracuj/header';
import '@grupa-pracuj/header/dist/styles.css';
import { SERVICE_NAME, API_TRANSLATIONS, NAVIGATION_ENVIRONMENT } from 'config';
import createHttp from 'src/api/http';
import Cookies from 'js-cookie';
import { bootstrapClient } from 'src/bootstrap';
import env from 'src/common/enviroment';
import navigationUrls from 'src/navigation';
import {
  attach,
  getNavigation,
  getConfig,
  getTranslation,
  GoogleTranslator,
  getUserFromCookie as getPracuj3User,
  availableHeaderMobileLayouts,
} from '@grupa-pracuj/header-library-sip/dist/esm/client';
import '@grupa-pracuj/ui-library-sip/dist/esm/header.css';

const bottomMenuActiveItemStrategies = new Map([
  ['offer-page', 'none'],
  ['home-page', 'homepage'],
  ['default', 'none'],
]);

const bottomMenuActiveItemStrategiesPracuj3 = new Map([
  ['offer-page', 'none'],
  ['home-page', 'home'],
  ['default', 'none'],
]);

const mobileLayoutStrategiesPracuj3 = new Map([
  ['offer-page', availableHeaderMobileLayouts.offer],
  ['home-page', availableHeaderMobileLayouts.base],
  ['default', availableHeaderMobileLayouts.base],
]);

const navigationLinks = navigationUrls[NAVIGATION_ENVIRONMENT];

const mobileLayoutStrategies = new Map([
  [
    'offer-page',
    () => {
      const previousNavigationLink =
        document.referrer || navigationLinks.LINK_JOB_OFFERS;
      return header.createBackTitleSearchLayout({
        previousNavigationLink,
        title: 'Oferta pracy',
      });
    },
  ],
  ['home-page', header.createStandardLayout],
  ['default', header.createStandardLayout],
]);

const bootstrapApplication = () => {
  const container = document.querySelector(
    `[data-application-name="${SERVICE_NAME}"]`
  );

  const {
    dataset: { fragmentHost },
  } = container;

  if (Cookies.get('gp_pracuj3.0.5') === 'B') {
    attach({
      container,
      navigation: getNavigation(navigationLinks),
      config: getConfig({
        displayBottomMenu: true,
        isBrowserSupported: env.isSupportedBrowser,
        bottomMenuActiveItem:
          bottomMenuActiveItemStrategiesPracuj3.get(fragmentHost),
        backIfNoHistoryLink: {
          href: navigationLinks.LINK_JOB_OFFERS,
        },
        isBetaMode: true,
      }),
      user: getPracuj3User(),
      translations: getTranslation(
        'pl',
        undefined,
        undefined,
        GoogleTranslator,
        {
          translationsEndpoint: API_TRANSLATIONS,
          http: createHttp(),
        },
        true
      ),
      layoutMobile: mobileLayoutStrategiesPracuj3.get(fragmentHost),
    });
  } else {
    header.attach({
      container,
      navigation: header.getNavigation(navigationLinks),
      user: header.getUserFromCookie(),
      isUnsupportedBrowser: !env.isSupportedBrowser,
      translationsEndpoint: API_TRANSLATIONS,
      http: createHttp(),
      bottomMenuConfig: {
        activeItem: bottomMenuActiveItemStrategies.get(fragmentHost),
        displayBottomMenu: true,
      },
      customizationConfig: {
        shouldDisplayCookiePolicy: false,
        desktopLayout: header.createStandardLayout,
        mobileLayout: mobileLayoutStrategies.get(fragmentHost),
      },
    });
  }
};

document.addEventListener(
  'application::ready',
  bootstrapClient(bootstrapApplication)
);

if (module.hot) {
  module.hot.accept();
}
